var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.5V34.5455C38 38.3455 34.8909 41.4545 31.0909 41.4545H18.4818C16.6164 41.4545 14.8545 40.7118 13.5591 39.3991L0 25.6155C0 25.6155 2.17636 23.4909 2.24545 23.4564C2.62545 23.1282 3.09182 22.9555 3.61 22.9555C3.99 22.9555 4.33545 23.0591 4.64636 23.2318C4.71545 23.2491 12.0909 27.4809 12.0909 27.4809V6.90909C12.0909 5.47545 13.2482 4.31818 14.6818 4.31818C16.1155 4.31818 17.2727 5.47545 17.2727 6.90909V19H19V2.59091C19 1.15727 20.1573 0 21.5909 0C23.0245 0 24.1818 1.15727 24.1818 2.59091V19H25.9091V4.31818C25.9091 2.88455 27.0664 1.72727 28.5 1.72727C29.9336 1.72727 31.0909 2.88455 31.0909 4.31818V19H32.8182V9.5C32.8182 8.06636 33.9755 6.90909 35.4091 6.90909C36.8427 6.90909 38 8.06636 38 9.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.bf480eed7903828ce2f85cec6f4af377.svg";
export { ForwardRef as ReactComponent };